import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { NotebookMessageFileCreate } from "@notebook/domain/models/notebook-message.model";
import type { NotebookMessageRepository } from "@notebook/domain/repositories/notebook-message.repository";
import { notebookTypes } from "@notebook/notebook-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class NotebookMessageFileCreateUseCase {
    constructor(
        @inject(notebookTypes.repositories.NotebookMessageRepository)
        private readonly notebookMessageRepository: NotebookMessageRepository,
    ) {}

    async execute(
        notebookId: string,
        notebookMessageId: string,
        notebookMessageFile: NotebookMessageFileCreate,
    ): Promise<boolean> {
        const createResult = await this.notebookMessageRepository.createFile(
            notebookId,
            notebookMessageId,
            notebookMessageFile,
        );

        if (createResult.isErr()) {
            ToastManagerRepository.error(createResult.error.message);
        }

        return createResult.isOk();
    }
}
